import React from 'react';

import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { IconTypes } from '@eika/icon';
import { ErrorLabel } from '@eika/label';

import { PendingCardStatus, PendingCardTokenItem } from '@/domain/digital-wallet';

import { getStatusForCardToken } from '@domain/digital-wallet/utils/pending-cards-mapper';
import useText from '@hooks/use-text';

import './ApplePayPendingCardToken.scss';

type Props = {
    id: string;
    pendingCardTokens: PendingCardTokenItem[];
    statusArray: PendingCardStatus[];
    activateCardToken: (pendingCardToken: PendingCardTokenItem) => void;
    hasLoading: boolean;
    label: string;
};

const ApplePayPendingCardTokenActivationButton: React.FC<Props> = ({
    id,
    pendingCardTokens,
    statusArray,
    hasLoading,
    activateCardToken,
    label,
}) => {
    const text = useText();

    if (pendingCardTokens.length === 0) return null;
    const status = getStatusForCardToken(pendingCardTokens[0], statusArray);
    return (
        <article className="pending-card-detail__item">
            <ButtonWithSpinner
                showSpinner={status === 'loading'}
                disabled={hasLoading}
                onClick={() => activateCardToken(pendingCardTokens[0])}
                showSuccess={status === 'success'}
                data-testid={status !== 'success' ? 'activate-pending-card-button' : 'activate-pending-card-success'}
                id={id}
            >
                {label}
            </ButtonWithSpinner>
            {status === 'error' && <ErrorLabel text={text.couldNotActivateCard} icon={IconTypes.UTROPSTEGN_24} />}
        </article>
    );
};

export default ApplePayPendingCardTokenActivationButton;
